"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.formReset = formReset;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
var _formModified = require("../form-modified");
var _updateInputStateValueIfChanged = require("../update-input-state-value-if-changed");
function formReset() {
  return function (getState, dispatch) {
    const {
      formElement,
      inputStates
    } = getState();
    formElement.reset();
    dispatch((0, _formModified.formModified)(false));
    (0, _forEach.default)(inputStates).call(inputStates, (inputState, inputElement) => {
      dispatch((0, _updateInputStateValueIfChanged.updateInputStateValueIfChanged)(inputElement, 'errorState', {}));
      dispatch((0, _updateInputStateValueIfChanged.updateInputStateValueIfChanged)(inputElement, 'errorStateOverride', {}));
    });
  };
}